import { generatePath, Outlet, useParams } from 'react-router-dom';
import {
  DateInputRange,
  PickerPosition,
  SchemaFilterType,
  Tabs,
} from '@ui/src';
import useAmlStatements from './hooks/use-aml-statements';
import { AmlAccountsStatementsTypes } from './types';

import cn from './styles.module.css';

const AmlStatements = ({
  matchPath,
  transactionsPath,
  cardsTransactionsPath,
  title,
  customerType,
  accounts,
  cards,
  cardsEnabled,
  sendMessage,
}: AmlAccountsStatementsTypes) => {
  const { customerId } = useParams();

  const {
    dates,
    setDates,
    filters,
    onFilter,
    customerTransactionsIsFetching,
    customerTransactionsIsLoading,
    errorList,
    setPage,
  } = useAmlStatements({
    matchPath,
    customerType,
    customerId,
  });

  return (
    <>
      <div className={cn.accountTransactionHistoryTitle}>
        <div className={cn.accountTransactionHistoryTitleLeft}>
          <div className={cn.accountTransactionHistoryTitleText}>{title}</div>
        </div>
        <div>
          <DateInputRange
            placeholder="All time"
            className={cn.historyDatePicker}
            values={dates}
            onChangeRange={(values) => {
              setDates(values.map((item) => item.toISOString()));

              const nextFilters = {
                ...filters,
              };

              if (values) {
                nextFilters.transferDateFrom = {
                  value: [values[0].toISOString()],
                  type: SchemaFilterType.STRING,
                };

                if (values.length > 1) {
                  nextFilters.transferDateTo = {
                    value: [values[1].toISOString()],
                    type: SchemaFilterType.STRING,
                  };
                }
              }

              onFilter(nextFilters);
            }}
            onReset={() => {
              const nextFilters = { ...filters };

              delete nextFilters.transferDateFrom;
              delete nextFilters.transferDateTo;

              setDates([]);

              onFilter(nextFilters);
            }}
            withoutTwoPickers
            pickerPisition={PickerPosition.RIGHT}
          />
        </div>
      </div>
      {cardsEnabled && (
        <div className={cn.accountTransactionTabs}>
          <Tabs
            tabs={[
              {
                name: 'Account transactions',
                path: generatePath(transactionsPath, {
                  customerId,
                }),
              },
              {
                name: 'Card transactions',
                path: generatePath(cardsTransactionsPath, {
                  customerId,
                }),
              },
            ]}
            enableRouting
          />
        </div>
      )}
      <Outlet
        context={{
          accounts,
          cards,
          customerTransactionsIsFetching,
          customerTransactionsIsLoading,
          errorList,
          setPage,
          sendMessage,
        }}
      />
    </>
  );
};

export default AmlStatements;
